import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShapesPlusXSquareCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shapes-plus-x-square-circle, icon, icons, shapes, games"><path d="M7 3.75V7M7 7V10.25M7 7H3.75M7 7H10.25M19.2981 14.7019L17 17M17 17L14.7019 19.2981M17 17L14.7019 14.7019M17 17L19.2981 19.2981M17 10.25C15.2051 10.25 13.75 8.79493 13.75 7C13.75 5.20507 15.2051 3.75 17 3.75C18.7949 3.75 20.25 5.20507 20.25 7C20.25 8.79493 18.7949 10.25 17 10.25ZM3.75 13.75H10.25V20.25H3.75V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShapesPlusXSquareCircle;
